import { useFirestoreLoaded } from '../../firebase/useFirestore';
import ToggleButton from '../common/ToggleButton';
import { MOMENT_MAIL_FIELD } from '../../helpers/personas/personaAlertText';

// Tenantinstelling: of de meldingen over meetmomenten ('bijna zover', 'te
// laat') ook in de dagelijkse mail komen. Achter het belicoon staan ze altijd;
// dit gaat alleen over de mail. Gevraagd door Het Blok (updateverzoek #19);
// een instelling en geen standaardgedrag op besluit van Gijs (2026-09-30).
//
// Gelezen door de nachtfunctie (functions/personas/sendDailyPersonaMail.js)
// met isFlagOn, dus de string 'true' die ToggleButton schrijft en een boolean
// true tellen allebei; afwezig is uit.
// AI-CONTEXT: See docs/features/meetmoment-melding.md

/**
 * @returns {JSX.Element}
 */
const MeasurementMomentMailSetting = () => {
    // Met laadvlag, niet de kale hook: een schakelaar die tijdens het laden
    // 'uit' toont terwijl hij aan staat, nodigt uit tot een klik die hem uitzet.
    // AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
    const [compagny, loaded] = useFirestoreLoaded('CompagnyMeta');
    const comp = Array.isArray(compagny) ? compagny[0] : undefined;

    // Drie takken, op zekerheid: nog niet bekend, bekend maar niets gevonden,
    // bekend. `loaded` staat ook op true als de read geweigerd is; dan zou een
    // eeuwige laadtekst het probleem verbergen.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    let inhoud;
    if (!loaded) {
        inhoud = <p className="status-config-loading">Instellingen worden geladen…</p>;
    } else if (!comp) {
        inhoud = (
            <p className="status-config-warning">
                De instellingen van je organisatie konden niet gelezen worden. Herlaad de pagina; blijft dit staan,
                neem dan contact op met Deccos.
            </p>
        );
    } else {
        // Met een tekst naast het knopje, zoals de andere schakelaars op dit
        // tabblad — zonder wist de tester niet wat hij aanzette (testronde
        // 2026-10-01, B3).
        inhoud = (
            <div className="settings-general-module-settings-item-container">
                <p>Meetmomenten ook in de dagelijkse mail</p>
                <ToggleButton
                    docid={comp.docid}
                    id={MOMENT_MAIL_FIELD}
                    collection="CompagnyMeta"
                    value={comp[MOMENT_MAIL_FIELD]}
                />
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            <h2>Mail bij meetmomenten</h2>
            <p>
                Zet je dit aan, dan staat elke nieuwe melding over een meetmoment ook in de dagelijkse
                mail: zodra een meetmoment van een deelnemer bijna aan de beurt is, en nogmaals als hij
                te laat is. Achter het belicoon staan deze meldingen altijd.
            </p>
            {inhoud}
        </div>
    );
};

export default MeasurementMomentMailSetting;
